const faqs = [
  {
    id: 1,
    q: 'YY漫画是免费的吗？',
    a: '是的，YY漫画平台上所有韩漫、日漫均免费全集阅读。我们致力于为漫迷提供无障碍的漫画阅读体验，无需付费即可畅享海量正版漫画资源。',
  },
  {
    id: 2,
    q: '如何追更喜欢的漫画？',
    a: '在漫画详情页点击「收藏」按钮即可将漫画加入你的收藏夹。漫画更新时，我们会通过站内通知第一时间提醒你，让你不错过每一话的精彩内容。',
  },
  {
    id: 3,
    q: '下拉式阅读怎么使用？',
    a: 'YY漫画采用下拉式阅读模式，打开任意漫画章节后，只需向下滑动即可连续阅读，无需手动翻页。这种流畅的阅读方式让你沉浸在漫画世界中不受打断。',
  },
  {
    id: 4,
    q: '智能推荐是怎么工作的？',
    a: '我们的智能推荐系统会根据你的阅读历史、收藏偏好和浏览行为，分析你的漫画口味，精准推荐你可能喜欢的新作品。使用越久，推荐越准。',
  },
  {
    id: 5,
    q: '韩漫和日漫更新速度如何？',
    a: '我们与多家漫画平台保持同步更新，热门韩漫日漫通常在官方发布后数小时内即可在YY漫画上阅读。每日更新超过100话，确保你能追到最新内容。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问答</h2>
          <p className="mt-2 text-sm text-foreground-500">关于追漫，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200/60">
          {faqs.map((faq) => (
            <details key={faq.id} className="group py-5 cursor-pointer" open>
              <summary className="flex items-center justify-between gap-4 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{faq.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed pl-0">{faq.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}